<template>
  <div class="template q-px-lg q-py-md">
    <div>
      <div class="flex row items-center q-pb-md">
        <h4>
          O Vega contingêngia deve ser habilitado em condicoes de falha
          sistêmica, que impossibilite o acesso pelo app Nota 10 ou
          indisponibilidade no sistema NETSMS e TOA.
        </h4>
      </div>
      <div class="profile flex row items-center q-mt-xl">
        <!-- <div class="avatar-user q-mr-sm">
          <q-img
            src="https://picsum.photos/500/300"
            width="100%"
            height="100px"
            fit="cover"
          />
        </div> -->
        <div class="col-12 flex row items-center justify-between flex-start" v-if="usuerLogged">
          <h3>{{ usuerLogged?.usuario }}</h3>
          <q-btn rounded unelevated color="red-9" @click="loagoutUser">
            Sair
          </q-btn>
          <!-- <h4>credenciada: {{ usuerLogged.credenciada }}</h4> -->
        </div>
      </div>
      <div class="q-mt-md" v-if="contigencyData != null">
        <h4>
          Contingência:
          {{ contigencyData.contingencia_ativa ? "Ativado" : "Desativado" }}
        </h4>
        <h4>Chamado: {{ contigencyData.chamado }}</h4>
        <h4>Responsável: {{ contigencyData.usuario_atualizacao }}</h4>
        <h4>Justificativa: {{ contigencyData.justificativa }}</h4>
        <h4>Data / Hora: {{ contigencyData.date }}</h4>
      </div>
    </div>

    <div class="flex column">
      <q-btn
        v-if="usuerLogged?.perfil == 'adm'"
        to="register-user"
        class="submit-btn"
        unelevated
        no-caps
        size="md"
        type="submit"
        label="Cadastrar usuário"
        rounded
        color="red-9"
      />
      <q-btn
        v-if="
          contigencyData == null || contigencyData.contingencia_ativa == false
        "
        to="enable-contingency"
        class="submit-btn q-mt-sm"
        unelevated
        no-caps
        size="md"
        type="submit"
        label="Ativar contigência"
        rounded
        color="red-9"
      />
      <q-btn
        v-else
        @click="disabledContingency"
        class="submit-btn q-mt-sm"
        unelevated
        no-caps
        size="md"
        label="Desativar contigência"
        rounded
        color="red-9"
      />
    </div>
  </div>
</template>

<script>
//-----VUEJS
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

//-----QUASAR
import { useQuasar } from "quasar";
//-----SERVICES
import ContingencyServices from "@/services/ContingencyServices";

//-----UTILS
import formatDate from "@/utils/dateFormat/dateFormate";
import { disableContigency } from "@/utils/ResquestOsForms/createContigencyAction.js";

export default {
  name: "ConfigAccredited",
  setup() {
    //----CONSTANTS
    const contigencyData = ref(null);
    const $q = useQuasar();
    const store = useStore();
    const usuerLogged = store.state.userData;
    const router = useRouter();
    //----VARIABLES
    let btnLoading = ref(false);
    let contingencyServices = new ContingencyServices();

    function isValidEmail(val) {
      if (auth.value.username.indexOf("@") < 0) {
        return true;
      }
      return emailPattern.test(val) || "Email inválido";
    }

    async function disabledContingency() {
      let data = disableContigency(usuerLogged.usuario, contigencyData.value);
      await contingencyServices
        .disableContingency(data)
        .then(async (response) => {
          $q.notify({
            message: "contingencia desativada",
            color: "green-9",
            position: "top",
          });
          btnLoading.value = false;
          router.push({ name: "config-history" });
        })
        .catch((error) => {
          $q.notify({
            message: error.response.data.toString(),
            color: "red-9",
            position: "top",
          });
          btnLoading.value = false;
        });
    }

    async function getHistoricalContingency() {
      await contingencyServices
        .getHistoricalContingency()
        .then((response) => {
          contigencyData.value = response[0];

          contigencyData.value.date = formatDate(response[0].data_atualizacao);
        })
        .catch((error) => {
          btnLoading.value = false;
          $q.notify({
            message: error.toString(),
            color: "red-9",
            position: "top",
          });
        });
    }

    function loagoutUser() {
      localStorage.removeItem("vega@token");
      localStorage.clear();

      window.location = "/";
    }

    onMounted(() => {
      getHistoricalContingency();
    });

    return {
      //----VARIABLES
      btnLoading,
      contigencyData,
      usuerLogged,

      //FUNCTIONS
      isValidEmail,
      disabledContingency,
      loagoutUser,
    };
  },
};
</script>
<style lang="scss">
.template {
  width: 100vw;
  height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background: #e5e5e5;

  h4 {
    margin: 0;
    color: rgba(0, 0, 0, 0.7);
    font-size: 1rem;
    font-family: Roboto;
    line-height: 18px;
  }

  .profile {
    display: flex;
    align-items: center;
    .avatar-user {
      width: 57px;
      height: 57px;
      border-radius: 9999px;
      overflow: hidden;
    }

    h3 {
      color: rgba(0, 0, 0, 0.7);
      font-size: 1rem;
      font-family: Roboto;
      margin: 0;
      line-height: 18px;
    }

    h4 {
      color: rgba(0, 0, 0, 0.5);
      font-size: 0.875rem;
      font-family: Roboto;
      margin: 0;
      margin: 0;
      line-height: 18px;
    }
  }
}
</style>
